import React, { useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import toast from 'react-hot-toast';
import './Login.css';

const VerifyOtp = () => {
  const { state } = useLocation();
  const navigate = useNavigate();

  const mobile = state?.mobile;
  const devOtp = state?.devOtp; // 👈 OTP from backend (DEV ONLY)

  const [otp, setOtp] = useState('');
  const [loading, setLoading] = useState(false);

  // 🚫 Prevent direct access
  if (!mobile) {
    navigate('/forgot-password');
    return null;
  }

  const handleVerify = async (e) => {
    e.preventDefault();

    if (!otp || otp.length < 4) {
      toast.error('Enter valid OTP');
      return;
    }

    try {
      setLoading(true);

      const res = await fetch(
        'https://playinbyd.com/api/api-verify-forget-otp',
        {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            app_key: 'SgRTXsywVmWteEBLlYWecwgbDiHwlh',
            env_type: 'Prod',
            mobile,
            otp
          })
        }
      );

      const data = await res.json();
      console.log('Verify OTP:', data);

      if (data.success) {
        toast.success('OTP verified');
        navigate('/change-password-before', { state: { mobile } });
      } else {
        toast.error(data.msg || 'Invalid OTP');
      }
    } catch (err) {
      toast.error('Server error');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="login-container">
      <div className="login-card">
        <div className="login-header">
          <h2>Verify OTP</h2>
          <p className="input-hint">OTP sent to {mobile}</p>
        </div>

        {/* 🚧 DEV OTP DISPLAY */}
        {devOtp && (
          <div
            style={{
              marginBottom: 16,
              padding: 12,
              background: 'rgba(59,130,246,0.15)',
              border: '1px dashed #3b82f6',
              borderRadius: 8,
              textAlign: 'center',
              fontWeight: 700,
              color: '#3b82f6'
            }}
          >
            DEV OTP: {devOtp}
          </div>
        )}

        <form onSubmit={handleVerify} className="login-form">
          <div className="form-group">
            <label>OTP *</label>
            <input
              type="text"
              value={otp}
              onChange={(e) =>
                setOtp(e.target.value.replace(/\D/g, '').slice(0, 6))
              }
              placeholder="Enter OTP"
              disabled={loading}
            />
          </div>

          <button
            type="submit"
            className="login-btn"
            disabled={loading}
          >
            {loading ? 'Verifying...' : 'Verify OTP'}
          </button>
        </form>
      </div>
    </div>
  );
};

export default VerifyOtp;
